import React from "react";
import classnames from 'classnames';
import './CodeSample.css';


export default function CodeSample(props) {
  return (
    <div
      className={classnames("CodeSample", props.className)}
      dangerouslySetInnerHTML={{ __html: props.code }}
    />
  )
}


// WEBPACK FOOTER //
// ./src/components/CodeSample.js